import {
  useModalOldContext,
  WSButton,
  WSButtons,
  WSElementProps,
  WSFormOld,
  WSModalOld,
  WSText,
  WSInputTextarea
} from "@wingspanhq/fe-component-library";
import { Payable, Payee } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { useHistory } from "react-router-dom";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesPayableRows, queriesPayables } from "@query";
import { QUERY_PAYABLES } from "../../../query/payments/keys";

type Props = WSElementProps;

export const REJECT_PAYABLE_MODAL = "REJECT_PAYABLE_MODAL";

export const RejectPayableModal: React.FC<Props> = () => {
  const { closeModal } = useModalOldContext();
  const history = useHistory();
  const [rejectPayable, rejectPayableMeta] =
    queriesPayables.rejectPayable.useMutation({
      dependencies: [
        QUERY_PAYABLES,
        queriesPayableRows.searchPayableRows.queryKeyBase
      ]
    });

  return (
    <WSModalOld
      name={REJECT_PAYABLE_MODAL}
      size="S"
      onClose={() => {
        rejectPayableMeta.reset();
      }}
      title="Reject Payable"
    >
      {({
        payable,
        listName
      }: {
        payable?: Payable;
        payee?: Payee;
        listName?: "paid";
      }) => {
        return (
          <>
            <WSFormOld<{ comment: string }>
              onSubmit={({ comment }) => {
                if (payable) {
                  rejectPayable(
                    {
                      payableId: payable.id!,
                      // Rejecting from the modal asserts no precondition — the
                      // intent is "reject whatever this payable is now".
                      ifMatch: "*",
                      disputeInvoiceRequest: { reason: comment }
                    },
                    {
                      onSuccess: () => {
                        closeModal(REJECT_PAYABLE_MODAL);
                        history.push(
                          `/member/invoices/payables${
                            listName ? `/${listName}` : ""
                          }`
                        );
                      }
                    }
                  );
                }
              }}
            >
              <WSText mb="XL">
                Indicate the reason for the reject in the field below
              </WSText>

              <WSFormOld.Field
                mb="XL"
                name="comment"
                component={WSInputTextarea}
              />

              <ErrorAlert
                mb="XL"
                error={rejectPayableMeta.error}
                context="DisputeInvoice"
              />

              <WSButtons format="modal">
                <WSButton
                  name="rejectPayable"
                  loading={rejectPayableMeta.isLoading}
                >
                  Reject payable
                </WSButton>
                <WSButton.Secondary
                  onClick={() => {
                    rejectPayableMeta.reset();
                    closeModal(REJECT_PAYABLE_MODAL);
                  }}
                  type="button"
                >
                  Cancel
                </WSButton.Secondary>
              </WSButtons>
            </WSFormOld>
          </>
        );
      }}
    </WSModalOld>
  );
};
